"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("./context");
const react_hanger_1 = require("react-hanger");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.OsmosysForm = ({ initialData, children, mutate, transformValues, result, onSuccess, successBuffer = 0, }) => {
    const { state: { data }, setState, } = react_hanger_1.useSetState({
        data: initialData,
    });
    const router = use_react_router_1.default();
    const isMounted = react_1.useRef(true); // ? (se [222] below
    react_1.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);
    const mutateWithData = react_1.useCallback(() => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        const promisedResult = yield mutate({
            variables: transformValues(data),
        });
        if (isMounted.current) {
            setTimeout(() => {
                if (isMounted.current) {
                    onSuccess(promisedResult.data, router);
                }
            }, successBuffer);
        }
        return promisedResult;
    }), [data, mutate, transformValues, isMounted]);
    return (react_1.default.createElement(context_1.OsmosysFormContextProvider, { value: {
            data,
            initialData,
            onFieldChange: (field, value) => {
                setState({
                    data: Object.assign(Object.assign({}, data), { [field]: value }),
                });
            },
            onSuccess,
            result,
            setState,
            submit: () => {
                mutateWithData();
            },
            successBuffer,
            transformValues,
        } }, children));
};
//# sourceMappingURL=OsmosysForm.js.map